var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "timesheet" }, [
    _c("div", { staticClass: "layout-header" }, [
      _c("div", { staticClass: "layout-title" }, [
        _c("b", [_vm._v("Табель")]),
        _vm._v(" " + _vm._s(_vm.timesheetName) + " "),
        _c(
          "div",
          { staticStyle: { "font-size": "15px", "margin-top": "5px" } },
          [_vm._v("Все смены")]
        ),
      ]),
    ]),
    _c("div", { staticClass: "timesheet__content" }, [
      _vm.inited
        ? _c(
            "div",
            { staticClass: "timesheet-chart" },
            [
              _vm.loading
                ? _c("Loader", {
                    attrs: {
                      active: _vm.loading,
                      label: "Производится расчет",
                      height: 434,
                    },
                  })
                : _vm._e(),
              !_vm.loading
                ? [
                    _c("div", { staticClass: "timesheet-chart__table" }, [
                      _c(
                        "table",
                        { staticClass: "h-table" },
                        [
                          _c("thead", [
                            _c(
                              "tr",
                              _vm._l(_vm.columns, function (column) {
                                return _c(
                                  "th",
                                  {
                                    key: column.code,
                                    staticClass: "timesheet-chart-column",
                                    class:
                                      "timesheet-chart-column__" + column.code,
                                    style: {
                                      width:
                                        column.code === "days"
                                          ? _vm.days.length * 23 + "px"
                                          : false,
                                      "max-width":
                                        column.code === "days"
                                          ? _vm.days.length * 23 + "px"
                                          : false,
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "h-table__header" },
                                      [
                                        column.code === "days"
                                          ? [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "h-table__col-title",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(_vm.monthName) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "timeline" },
                                                _vm._l(
                                                  _vm.chartData.total.days,
                                                  function (day) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: day.key,
                                                        staticClass: "day",
                                                        class: {
                                                          conflict:
                                                            day.hasConflict,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(day.day) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          : [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "h-table__col-title",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "title" },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            [
                                                              column.ultraShortName,
                                                              column.unit ===
                                                                "ruble" && "฿",
                                                              column.unit ===
                                                                "ruble/unit" &&
                                                                "฿/шт.",
                                                              column.unit ===
                                                                "HH:MM" &&
                                                                "чч:мм",
                                                            ]
                                                              .filter(Boolean)
                                                              .join(", ")
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                      ],
                                      2
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]),
                          _vm._l(_vm.positionsList, function (position) {
                            return [
                              _c(
                                "tr",
                                {
                                  key: position.code,
                                  staticClass: "position-name",
                                },
                                [
                                  _vm._l(_vm.columns, function (column) {
                                    return [
                                      column.code !== "days" &&
                                      column.code !== "loadType"
                                        ? _c(
                                            "td",
                                            {
                                              key: column.code,
                                              class:
                                                "position-name__" + column.code,
                                              attrs: {
                                                colspan:
                                                  column.code === "worker"
                                                    ? _vm.visibleColumns.includes(
                                                        "loadType"
                                                      )
                                                      ? 3
                                                      : 2
                                                    : 1,
                                              },
                                            },
                                            [
                                              _c("table-position-cell", {
                                                attrs: {
                                                  column: column.code,
                                                  position: position,
                                                  data:
                                                    _vm.chartData.positions[
                                                      position.code
                                                    ] || [],
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  }),
                                ],
                                2
                              ),
                              _c(
                                "tbody",
                                {
                                  key: position.code + "-workers",
                                  staticClass: "position-workers",
                                },
                                [
                                  _vm._l(
                                    (
                                      _vm.chartData.positions[position.code] ||
                                      []
                                    ).workers,
                                    function (worker) {
                                      return [
                                        _vm.shiftDayOrNight(worker)
                                          ? _c(
                                              "tr",
                                              {
                                                key: worker.id,
                                                staticClass: "worker-data",
                                              },
                                              _vm._l(
                                                _vm.columns,
                                                function (column) {
                                                  return _c(
                                                    "td",
                                                    {
                                                      key: column.code,
                                                      class:
                                                        "worker-data__" +
                                                        column.code,
                                                    },
                                                    [
                                                      _c("table-cell", {
                                                        attrs: {
                                                          column: column.code,
                                                          worker: worker,
                                                          position: position,
                                                          filial:
                                                            _vm.currentTimesheet &&
                                                            _vm.currentTimesheet
                                                              .filial.id,
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          : _vm._e(),
                                      ]
                                    }
                                  ),
                                ],
                                2
                              ),
                            ]
                          }),
                          _c("tbody", { staticClass: "tfoot" }, [
                            _c(
                              "tr",
                              [
                                _vm._l(_vm.columns, function (column) {
                                  return [
                                    column.code !== "loadType"
                                      ? _c(
                                          "td",
                                          {
                                            key: column.code,
                                            staticClass:
                                              "timesheet-total-column",
                                            class:
                                              "timesheet-total-column__" +
                                              column.code,
                                            attrs: {
                                              colspan:
                                                column.code === "worker" &&
                                                _vm.visibleColumns.includes(
                                                  "loadType"
                                                )
                                                  ? 2
                                                  : 1,
                                            },
                                          },
                                          [
                                            _c("table-total-cell", {
                                              attrs: {
                                                column: column.code,
                                                workers: _vm.workersList,
                                                stats: _vm.chartData.total,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                }),
                              ],
                              2
                            ),
                          ]),
                        ],
                        2
                      ),
                    ]),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }